import Table from "components/Table/Table";
import { commonColumnProps, OFFSET, PAGE_SIZE } from "constants/TableConstants";
import { useEffect, useState } from "react";
import type { CellClickArgs } from "react-data-grid";
import { useLocation, useNavigate } from "react-router-dom";
import { setIsLoading } from "reducers/main";
import { useGetAdjustersQuery } from "services/adjuster-api";
import type { AdjusterType } from "types/DataTypes";
import { useQuery } from "utils/hooks";
import { useDispatch } from "utils/redux";
import { GLOBAL_SEARCH_PARAM } from "utils/useUrlStore";

import InsurerTPAPageContainer from "../insurer/InsurerTPAPageContainer";

const ADJUSTER_COLUMNS = [
  { key: "name", name: "Name", ...commonColumnProps },
  { key: "email", name: "Email", ...commonColumnProps },
  { key: "phone", name: "Phone", ...commonColumnProps },
  { key: "city", name: "City", ...commonColumnProps },
  { key: "state", name: "State", ...commonColumnProps },
  {
    key: "zip",
    name: "ZIP Code",
    render: (value: string | null) => value || "-",
  },
];

const AdjusterTable = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const query = useQuery();
  const [page, setPage] = useState(1);

  const { data: adjusters = { results: [], count: 0 }, isLoading } =
    useGetAdjustersQuery(
      {
        searchTerm: query.get(GLOBAL_SEARCH_PARAM) || undefined,
        limit: PAGE_SIZE,
        offset: OFFSET(page),
      },
      { skip: false },
    );

  const handleCellClick = (args: CellClickArgs<AdjusterType, unknown>) => {
    navigate(`${location.pathname}/${args.row.id}/overview`);
  };

  useEffect(() => {
    dispatch(setIsLoading(isLoading));
  }, [dispatch, isLoading]);

  return (
    <InsurerTPAPageContainer>
      <Table
        className="adjusters-table"
        columns={ADJUSTER_COLUMNS}
        rows={adjusters.results}
        rowKeyGetter={(row: AdjusterType) => row.id}
        onCellClick={handleCellClick}
        isLoading={isLoading}
        fullHeight
        pagination={{
          pageSize: PAGE_SIZE,
          pageIndex: page,
          rowCount: adjusters.count,
          onPageChange: setPage,
          isLoading,
        }}
      />
    </InsurerTPAPageContainer>
  );
};

export default AdjusterTable;
